import { gql } from '@/__generated__/gql';

export const UPDATE_CALCULATIONS_MUTATION = gql(`
  mutation SuperAdminSettingsUpdateCalculations {
    updateCalculations
  }
`);

export const UPDATE_AGGREGATE_INTEREST_MUTATION = gql(`
  mutation SuperAdminSettingsCalculateAndUpdateAggregateInterest {
    calculateAndUpdateAggregateInterest
  }
`);

export const UPDATE_AGGREGATE_COMMITMENT_MUTATION = gql(`
  mutation SuperAdminSettingsCalculateAndUpdateAggregateCommitment {
    calculateAndUpdateAggregateCommitment
  }
`);
